import { type Organization, type Skill } from "@entities";
import { TextField } from "@mui/material";
import {
  organizationManagerRepo,
  organizationRepo,
  skillRepo,
  teamManagerRepo,
  teamRepo,
} from "@repositories";
import { BaseRoles } from "@shared/Roles";
import { useEffect, useState, type ChangeEvent, type FC } from "react";
import { UploadImage } from "../../components/form-components/image-uploader/ImageUploader";
import { BasicButton } from "../../components/generic-components/button/Button";
import { useAlert } from "../../contexts/AlertProvider";
import { useUser } from "../../contexts/UserProvider";
import "./OrganizationRegister.scss";

export const OrganizationRegister: FC = () => {
  const [organizationDetails, setOrganizationDetails] = useState<Organization>(
    {} as Organization,
  );
  const [, setSkills] = useState<Skill[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [profileImg, setProfileImg] = useState<string>("");
  const [adminName, setAdminName] = useState<string>("");
  const [phoneNumber, setPhoneNumber] = useState<string>("");
  const { setAlertText, setSeverity } = useAlert();

  useEffect(() => {
    getSkills();
  }, []);

  const getSkills = async () => {
    setSkills(await skillRepo.find());
  };

  const handleOrganizationDetailsChange = (
    event: ChangeEvent<HTMLInputElement>,
    field: keyof Organization,
  ) => {
    setOrganizationDetails({
      ...organizationDetails,
      [field]: event.target.value,
    });
  };

  const saveOrganization = async () => {
    if (isLoading) return;
    const formattedPhoneNumber =
      "+972" + (phoneNumber ? phoneNumber.slice(1) : "");
    setIsLoading(true);
    const organization = await organizationRepo.insert({
      ...organizationDetails,
      organizationImageId: profileImg || "33b0cfec-11a3-4b34-ba81-b12bfce4e931",
    });
    const organizationManager = await organizationManagerRepo.insert({
      name: adminName,
      phoneNumber: formattedPhoneNumber,
      organization,
      roles: [BaseRoles.Manager],
      profileImageId: "33b0cfec-11a3-4b34-ba81-b12bfce4e931",
    });
    const team = await teamRepo.insert({
      name: "כל המתנדבים",
      organization,
    });
    await teamManagerRepo.insert({
      teamId: team.id,
      managerId: organizationManager.id,
    });

    setIsLoading(false);
    setAlertText("הארגון נוצר בהצלחה");
    setSeverity("success");
  };

  const changePhoneNumber = (value?: string) => {
    setPhoneNumber(value || "");
  };

  return (
    <div className="organization-register-container">
      <>
        <div className="input-label">
          <label htmlFor="org-name">שם הארגון</label>
          <TextField
            id="org-name"
            type="text"
            value={organizationDetails?.name || ""}
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              handleOrganizationDetailsChange(event, "name")
            }
            dir="rtl"
          />
        </div>
        <div>
          <p>תמונת ארגון</p>
          <UploadImage
            name="profileImage"
            imageId={profileImg}
            handleImageChange={(imageId) => {
              setProfileImg(imageId);
            }}
          />
        </div>
        <div className="input-label">
          <label htmlFor="admin-name">שם המנהל</label>
          <TextField
            id="admin-name"
            type="text"
            value={adminName}
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              setAdminName(event.target.value)
            }
            dir="rtl"
          />
        </div>
        <div className="input-label">
          <label htmlFor="admin-phone">מספר טלפון מנהל</label>
          <TextField
            id="admin-phone"
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- E164Number type
            value={phoneNumber as any}
            onChange={(event) => changePhoneNumber(event.target.value)}
          />
        </div>
        <BasicButton
          text="שמירת ארגון"
          isProgress={isLoading}
          onClick={saveOrganization}
        />
      </>
    </div>
  );
};
